import type {DocumentManager} from '@wix/document-manager-core'
import type {Experiment} from '@wix/document-services-types'
import * as constants from '../../../../constants/constants'
import type {MasterPageMigrator} from '../dataMigrationRunner'
import type {DataExtensionAPI} from '../../../data'

const ATOMIC_SCOPES = constants.DATA_TYPES.atomicScopes
const ATOMIC_SCOPES_PREFIX = 'atomicScopes'

const migrateMasterPage = (dm: DocumentManager, experimentInstance: Experiment) => {
    if (!experimentInstance.isOpen('dm_cleanupAtomicScopesGarbage')) {
        return
    }

    const {data} = dm.extensionAPI as DataExtensionAPI
    const atomicScopesGarbageIds = data.queryKeys(
        ATOMIC_SCOPES,
        'masterPage',
        (value: any, key: string): boolean => value && key.startsWith(ATOMIC_SCOPES_PREFIX)
    )
    atomicScopesGarbageIds.forEach(atomicScopeId => {
        dm.dal.remove(dm.pointers.getPointer(atomicScopeId, ATOMIC_SCOPES))
    })
}

const name = 'cleanupAtomicScopesGarbage'
const version = 0

const experimentalVersions = [{experiment: 'dm_cleanupAtomicScopesGarbage', version: 1}]

export const cleanupAtomicScopesGarbage: MasterPageMigrator = {
    migrateMasterPage,
    name,
    version,
    experimentalVersions
}
